<div class="second-right side-area">
    

    <div class="left-side side">
        <div class="side__block block">
            <div class="block__title">Отправитель</div>
            <div class="block__line" v-show="dataForm.sender.senderType">
                <b>Организация:</b>{{dataForm.sender.name}}
            </div>
            <div class="block__line" v-show="!dataForm.sender.senderType">
                <b>ФИО:</b>{{joinFullName(
                    dataForm.sender.surnameSender,
                    dataForm.sender.firstNameSender,
                    dataForm.sender.secondNameSender
                  )}}
            </div>
            <div class="block__line" v-show="dataForm.sender.senderType">
                <b>ИНН:</b>{{dataForm.sender.innSender}}
            </div>
            <div class="block__line">
                <b>Телефон:</b>{{dataForm.sender.phoneSender}}
            </div>
            <div class="block__line" >
                <b>Город:</b>{{dataForm.sender.cityFrom}}
            </div>
            <div class="block__line" v-show="dataForm.applicationCargoPickup.isCargoPickup">
                <b>Адрес забора:</b>{{dataForm.applicationCargoPickup.addressCargoPickup}}
            </div>
            <div class="block__line" v-show="dataForm.applicationCargoPickup.isCargoPickup">
                <b>Время:</b>{{dataForm.applicationCargoPickupTime.cargoTimePickup.intervalTitle}}
            </div>
        </div>
        <div class="side__block block">
            <div class="block__title">Получатель</div>
            <div class="block__line" v-show="dataForm.consignee.consigneeType">
                <b>Организация:</b>{{dataForm.consignee.name}}
            </div>
            <div class="block__line" v-show="!dataForm.consignee.consigneeType">
                <b>ФИО:</b>{{joinFullName(
                    dataForm.consignee.surnameConsignee,
                    dataForm.consignee.firstNameConsignee,
                    dataForm.consignee.secondNameConsignee
                )}}
            </div>
            <div class="block__line" v-show="dataForm.consignee.consigneeType">
                <b>ИНН:</b>{{dataForm.consignee.innConsignee}}
            </div>
            <div class="block__line">
                <b>Телефон:</b>{{dataForm.consignee.phoneConsignee}}
            </div>
            <div class="block__line">
                <b>Город:</b>{{dataForm.consignee.cityTo}}
            </div>
            <div class="block__line" v-show="dataForm.applicationCargoPickup.deliveryToTheAddress">
                <b>Адрес доставки:</b>{{dataForm.applicationCargoPickup.addressConsignee}}
            </div>
            <div class="block__line" v-show="dataForm.applicationCargoPickup.deliveryToTheAddress">
                <b>Время:</b>{{dataForm.applicationCargoPickupTime.cargoTimePickupDelivery.intervalTitle}}
            </div>
        </div>
    </div>
    <div class="right-side side">
        <div class="side__block block">
            <div class="block__title">Данные о грузе</div>
            <div class="block__line">
                <b>Кол-во мест:</b>
                {{ (dataForm.cargoInformation.cargoSpaceType == "simple") ? ((dataForm.packages.additionalPackagingGroup.length > 0) ? 1 : dataForm.cargoInformation.numberOfIdenticalLoads) : dataForm.cargoSpaceTabs.length}}
            </div>
            <div class="block__line">
                <b>Вес:</b>{{(dataFormApi.totalWeight) ? dataFormApi.totalWeight : ""}} кг
            </div>
            <div class="block__line">
                <b>Объем:</b>{{(dataFormApi.cargoVolume) ? dataFormApi.cargoVolume : ""}} м3
            </div>
            <div class="block__line">
                <b>Объявленная стоимость груза:</b> {{dataFormApi.currencyCount(dataForm.other.cargoCost)}} {{dataFormApi.currencyCountry == "ru" ? " ₽" : " ₸" }}
            </div>
        </div>
        <div class="side__block block" id="uslugi-area">
            <div class="block__title">Услуги</div>
            <div class="block__line" id="package-list">
                
            </div>
            <div class="block__line">
                <b>Доп. услуги:</b><span id="usligi-list"></span>
            </div>
        </div>
        <div class="side__block block block_type_money">
            <div class="block__cost">
                <div class="frame__data__common-price"> <div class="unbold">Итого:</div> {{dataFormApi.commonPrice != "Загрузка..." ? (dataFormApi.commonPrice ? dataFormApi.currencyCount(dataFormApi.commonPrice) + (dataFormApi.currencyCountry == "ru" ? " руб" : " тенге") : "") : dataFormApi.commonPrice}}.</div>
            </div>
            <div class="block__desc">
                Информация в калькуляторе, в т.ч. о стоимости услуг, не является публичной офертой и может отличаться для конкретного груза.
                После фактического взвешивания и измерения объёма груза на складе, указанные клиентом данные могут быть изменены перевозчиком, исходя из фактического веса/объёма груза.
            </div>
        </div>

    </div>
    <el-dialog custom-class="tk-dialog tk-dialog-small" v-model="dataForm.windowShow" :show-close="false" width="500">
        <template #header="{ close, titleId, titleClass }">
        <div class="my-header">
            <h4 :id="titleId" :class="titleClass" class="break-word">Похоже на сервере наблюдаются неполадки, вы можете оформить экспедиторскую расписку или забор груза по следующий ссылкам или попробовать повторно отправить заявку</h4>
        </div>
        </template>
        <div id="errorText">
        Код ошибки: {{dataForm.windowError}}
        </div>
        <a class="el-button el-button--primary m-err close-button" href="https://order.tk-luch.ru/forwardin-receipt"><span class="">Экспедиторская расписка</span></a>
        <a class="el-button el-button--primary m-err close-button" href="https://order.tk-luch.ru"><span class="">Забор груза</span></a>
        <button class="el-button el-button--primary m-err close-button" type="button" @click="dataForm.windowShow = false"><span class="">Закрыть</span></button>
    </el-dialog>
    <div class="description-notify">
        Информация на сайте, в т.ч. о стоимости услуг, не является публичной офертой и может отличаться для конкретного груза. После фактического взвешивания и измерения объёма груза на складе, указанные клиентом данные могут быть изменены перевозчиком, исходя из фактического веса/объёма груза.
    </div>
    <div class="description-notify" style="margin-top: 0; padding-top: 0;">
        Перед отправкой возможен досмотр груза, в соответствии с требованиями Федерального закона № 16-ФЗ «О транспортной безопасности», Федерального закона № 87-ФЗ «О транспортно-экспедиционной деятельности», а также на основании предписания Управления ФСБ по Челябинской области. Для отправки потребуется паспорт или другой документ удостоверяющий личность. От представителей организации доверенность или печать.
    </div>

    <el-form-item class="calculator__toggles politics-toggle" prop="payment.isAgreeDataProcessing">
        
        <div class="calculator__toggle">
            <div class="calculator__toggle-inner">
                <el-switch v-model="dataForm.payment.isAgree" />
            </div>
            <div class="politics-text">Я даю согласие на обработку моих&nbsp;<a class="politics-link" target=”_blank” href="https://xn----stbeziy.xn--p1ai/wp-content/uploads/2025/08/polozhenie_ob_obrabotke_i_zashhite_personalnyh_dannyh_ooo_uk_luch_25.pdf">персональных данных</a></div>
        </div>
    </el-form-item>



    <!-- <el-form-item class="calculator__toggles politics-toggle" prop="payment.isAgreeEmailMailing">
        <div class="calculator__toggle">
            <div class="calculator__toggle-inner">
                <el-switch v-model="dataForm.payment.isAgreeEmailMailing" />
            </div>
            <div class="politics-text">Я хочу подписаться на Email рассылку</div>
        </div>
    </el-form-item> -->

    
    
</div>

<div class="calculateArrow nav-buttons__releative">
    <div class="step-counter">{{ dataForm.paymentAgreeStep }}/{{ dataForm.totalSteps }}</div>
    <div class="arrows-steps-prev" @click="$emit('click-button-back');lastPageSwitchStyle();"></div>
    <div v-if="dataForm.applicationCargoPickup.isCargoPickup == true">
        <el-button type="primary" class="sendButton"
        @click="$emit('submit-form-sender', ruleFormRef)"
        :disabled="!dataForm.payment.isAgree"
        >Отправить заявку</el-button>
    </div>
    <div v-else>
        <el-button type="primary" class="sendButton"
        @click="$emit('submit-form-sender', ruleFormRef)"
        :disabled="!dataForm.payment.isAgree"
        >Создать расписку</el-button>
    </div>
</div>



